<template>
  <v-app>
    <v-content class>
      <v-img :src="this.companySiteImage" :height="this.$vuetify.breakpoint.height">
        <v-dialog v-model="dialog" persistent width="300">
          <LoginForm v-if="toggleProgressBar" />
          <v-card color="primary" dark v-if="!toggleProgressBar">
            <v-card-text>
              Please wait. Downloading... {{downloadProgress}}%
              <v-progress-linear v-model="downloadProgress" determinate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-img>
    </v-content>
  </v-app>
</template>

<script>
// @ is an alias to /src
import LoginForm from "@/components/LoginForm.vue";

export default {
  name: "Home",
  components: {
    LoginForm,
  },
  data: () => ({
    companySiteImage: "",
    dialog: true,
    toggleProgressBar: false,
    downloadProgress: 10,
  }),

  async created() {
    window.document.title = "Downloading...";
    const progressBar = setInterval(
      () =>
        this.downloadProgress === 100
          ? null
          : (this.downloadProgress = this.downloadProgress + 5),
      1000
    );

    console.log(window.height);
    const data = await this.$http(
      `https://functors.azurewebsites.net/api/testfunc?code=gDzDmtgc/bqftSyTCNi55N9MqXxRa6zvTAf8URvPUhSbYn9RoyjpQQ==&url=${
        this.$route.params.email.split("@")[1]
      }&width=${window.screen.width}&height=${window.screen.height}`
    );
    console.log(data);
    this.companySiteImage = `data:image/jpeg;charset=utf-8;base64,${data.data}`;
    this.toggleProgressBar = !this.toggleProgressBar;
    console.log(progressBar);
  },
};
</script>
